import {
  useMediaQuery,
} from "@mui/material";



/**
 * Create a linear gradient with a hard line between to colors
 * at the given percentage.
 */
export function hardLineGradient( color1, color2, pct ) {
  return `linear-gradient(90deg, ${color1} 0%, ${color1} ${pct}%, ${color2} ${pct}%, ${color2} 100%)`;
}



// Modified from https://stackoverflow.com/a/39914235
// Posted by Dan Dascalescu, modified by community. See post 'Timeline' for change history
// Retrieved 2025-12-02, License - CC BY-SA 4.0

/**
 * Wait the given number of milliseconds, then continue.
 * Useful in async functions with await, e.g.:
 *
 *     await sleep(1000);
 *
 */
export function sleep(ms) {
  return new Promise( resolve => setTimeout(resolve, ms) );
}

/**
 * Construct URL from CloudFront distribution URL and S3 key for videos and captions
 */

const CLOUDFRONT_DISTRIBUTION_URL = process.env.REACT_APP_CLOUDFRONT_DISTRIBUTION_URL;

export function constructCloudFrontURL(path) {
  if (!path) {
    return null;
  }
  if (!CLOUDFRONT_DISTRIBUTION_URL) {
    console.warn("REACT_APP_CLOUDFRONT_DISTRIBUTION_URL is not set in environment variables.");
    return null;
  }
  // Ensure no leading slash in path
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  return `${CLOUDFRONT_DISTRIBUTION_URL}/${cleanPath}`;
}


/**
 * Construct a URL object representing the given API endpoint.
 *
 * Includes any path after the host, which ensures the environment specifier is preserved.
 */
export function getAPIBaseURL(apiPath) {
  const baseUrl = process.env.REACT_APP_SERVER_URL;
  return new URL( apiPath, baseUrl.endsWith("/") ? baseUrl : baseUrl + "/" );
}


/**
 * Media query to adjust elements on shorter screens (in the y-direction),
 * as well as when zoomed in.
 *
 * Useful for vertical resizing of elements that don't benefit as much from
 * a standard horizontal breakpoint check.
 */
export function useScreenIsShort() {
  return useMediaQuery('(max-height: 1000px)', { noSsr: true });
}


/**
 * Screens too short for the full recording-page sidebar (e.g. 13" laptops,
 * iPad mini in landscape): the sidebar switches to a compact layout.
 */
export function useScreenIsCompact() {
  return useMediaQuery('(max-height: 800px)', { noSsr: true });
}


/**
 * Very short screens (e.g. phones in landscape): the sidebar shows only the
 * current step.
 */
export function useScreenIsTiny() {
  return useMediaQuery('(max-height: 500px)', { noSsr: true });
}
